module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "frontier.27b1a632.svg";